<template>
	<el-drawer :modal="false"  title="Register New User" name="drawer-create-user" :visible.sync="show_drawer" class="drawer-create-user"
		size="40%">
		<b-container>
			<b-row align-v="center" class="py-3" :class="isExceedUser ? 'bg-danger' : 'bg-success'">
				<b-col cols="6">
					<p class="text-muted">Total Registered Users</p>
					<h2 class="listing-title mb-0">{{ totalUsers }}</h2>
				</b-col>
				<b-col cols="6">
					<p class="text-muted">Remaining Quota</p>
					<h2 class="listing-title mb-0">{{ auth_user.subscription.privileges.scpk_limit_user }}</h2>
				</b-col>
			</b-row>
			<form @submit.prevent="submitRegister">
				<b-row align-v="center" class="py-3">
					<b-col v-if="double_message" md="12">
						<div class="alert alert-warning">{{ double_message }}</div>
					</b-col>
					<b-col md="12">
						<b-form-group label="Name" class="mb-3">
							<b-form-input v-model="formParams.name" type="text" required></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="6">
						<b-form-group class="mb-3" label="Email">
							<b-form-input v-model="formParams.email" type="email" v-on:focusout="checkEmailUser()"
								required></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="6">
						<b-form-group class="mb-3" label="Contact No">
							<b-form-input v-model="formParams.contact_number" type="number"></b-form-input>
						</b-form-group>
					</b-col>
					<b-col md="12">
						<b-form-group class="mb-3" label="Password">
							<b-input-group class="mb-3">
							<template #append>
								<b-input-group-text>
									<a href="javascript:void(0)" @click="is_show_password = !is_show_password">
										<b-icon :icon="!is_show_password ? 'eye' : 'eye-slash'" class="text-muted"></b-icon>
									</a>
								</b-input-group-text>
							</template>
							<b-form-input v-model="formParams.password" :type="is_show_password ? 'text' : 'password'"
								required></b-form-input>
							</b-input-group>
						</b-form-group>

					</b-col>
					<b-col md="12">
						<b-form-group class="mb-3" label="Confirm Password">
							<b-input-group class="mb-3">
							<template #append>
								<b-input-group-text>
									<a href="javascript:void(0)" @click="is_show_confirm_password = !is_show_confirm_password">
										<b-icon :icon="!is_show_confirm_password ? 'eye' : 'eye-slash'" class="text-muted"></b-icon>
									</a>
								</b-input-group-text>
							</template>
							<b-form-input v-model="formParams.password_confirmation" :type="is_show_confirm_password ? 'text' : 'password'"
								required></b-form-input>
							</b-input-group>

						</b-form-group>
					</b-col>
					<b-col md="12">
						<b-form-group class="mb-4" label="Role">
							<el-select v-model="formParams.role_id" filterable placeholder="Select Role">
								<el-option v-for="role in availableRoles" :key="role.role_id" :label="role.role_name"
									:value="role.role_id">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>
					<b-col md="12">
						<b-form-group class="mb-4" label="Upline">
							<el-select v-model="formParams.mlv_upl_id" filterable placeholder="Select Upline">
								<el-option v-for="upline in userUplineList" :key="upline.id"
									:label="upline.role.role_type + ' - ' + upline.user.name" :value="upline.id">
								</el-option>
							</el-select>
						</b-form-group>
					</b-col>
				</b-row>
				<b-row align-v="center" class="py-3">
					<b-col cols="12">
						<b-button variant="primary" class="btn-header btn-block" type="submit">Register</b-button>
					</b-col>
				</b-row>
			</form>
		</b-container>

	</el-drawer>
</template>
<script>
import { Drawer, Select, Option, Input, Button, Checkbox } from 'element-ui'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { useAuthStore } from '@/stores/authStore'
import { useConfigStore } from '@/stores/configStore'
import { useAccessControlStore } from '@/stores/accessControlStore'
import { mapActions, mapState } from 'pinia'
import {
	helperFunctionMixin,
	notifyFunctionMixin,
	axios,
	services,
	getHeader,
	debounce,
	swal
} from '@/assets/js/httpImports.js'
import _ from 'lodash'
export default {
	props: [],
	mixins: [
		helperFunctionMixin,
		notifyFunctionMixin
	],
	components: {
		ValidationObserver,
		ValidationProvider,
		[Input.name]: Input,
		[Button.name]: Button,
		[Select.name]: Select,
		[Option.name]: Option,
		[Checkbox.name]: Checkbox,
		[Drawer.name]: Drawer
	},
	computed: {
		...mapState(useAuthStore, ['auth_user']),
		...mapState(useConfigStore, ['app_code']),
		...mapState(useAccessControlStore, ['userList', 'roleList', 'userUplineList']),
		totalUsers() {
			return this.userList.length;
		},
		isExceedUser() {
			return this.totalUsers > this.auth_user.subscription.privileges.scpk_limit_user
		},
		availableRoles() {
			if (this.roleList.length > 0) {
				return this.roleList;
			}
			return [];
		}
	},
	async created() {

	},
	mounted() {
	},
	data() {
		return {
			show_drawer: false,
			formParams: {
				name: '',
				email: '',
				contact_number: '',
				password: '',
				password_confirmation: '',
				role_id: '',
				mlv_upl_id: '',
				status: '',
			},
			is_show_password: false,
			is_show_confirm_password: false,
			double_message: null,
			user_statuses: [
				'DRAFT/PENDING',
				'ACTIVE',
				'INACTIVE',
				'PROBATION',
				'SUSPEND',
				'BANNED'
			],
		}
	},
	methods: {
		...mapActions(useAuthStore, ['fetchUserInfo']),
		showDrawer() {
			this.show_drawer = !this.show_drawer;
		},
		closeDrawer() {
			this.show_drawer = false;
			this.resetFormToNull(this.formParams);
			this.$emit('close');
		},
		checkEmailUser() {
			this.double_message = null;
			if (!this.isEmpty(this.formParams.email)) {
				axios.get(services.access_control + 'user?email=' + this.formParams.email, { headers: getHeader() })
					.then(res => {
						let d = res.data.data;
						if (d.length > 0) {
							const groupedData = _.groupBy(d, 'id');
							const result = _.mapValues(groupedData, (group) => {
								return group.map(item => item.user_role_applications.map(role => role.application_code));
							});
							const exis_app = _.uniq(_.flatMap(result));
							const existing_app = (exis_app) ? exis_app.join(",") : '';
							if (existing_app.indexOf(this.app_code) !== -1) {
								this.double_message = " This email has been used";
							} else {
								this.double_message = " Please be note that this email has been associated with system on application code " + existing_app + ", the email and password will remain the same for both system login";
							}
						} else {
							this.double_message = null;
						}
					})
					.catch(e => {
						this.errorFunction(e)
					})
			}
		},
		submitRegister() {
			if (this.isExceedUser) {
				this.errorFunction(null, 'Your current subscription can only register ' + this.auth_user.subscription.privileges.scpk_limit_user + ' users.')
				return
			}

			let data = {
				"name": this.formParams.name,
				"password": this.formParams.password,
				"password_confirmation": this.formParams.password_confirmation,
				"email": this.formParams.email,
				"contact_number": this.formParams.contact_number,
				"role_apps": [
					{
						"role_id": this.formParams.role_id,
						"corporate_id": this.auth_user.account_info.corporate_id,
						"mlv_upl_id": this.formParams.mlv_upl_id, // for parent hierarchy value from user_role_applications.id
						"mlv_pos_que": null, //sequence hierarchy
						"is_use_corp_subscription": 1
					}
				],
				"status": 1 // active
			}

			axios.post(services.access_control + 'user', data, { headers: getHeader() })
				.then(res => {
					this.notifySuccess('<b>User:</b> - Successfully Created.')
					this.closeDrawer();
				})
				.catch(e => {
					this.errorFunction(e)
				})
		},

	}
}
</script>